require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-css-flexbox-use-the-flex-basis-property-to-set-the-initial-size-of-an-item.json") })
        }
      }, "path---responsive-web-design-css-flexbox-use-the-flex-basis-property-to-set-the-initial-size-of-an-item");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-css-flexbox-use-the-flex-basis-property-to-set-the-initial-size-of-an-item!./.cache/json/responsive-web-design-css-flexbox-use-the-flex-basis-property-to-set-the-initial-size-of-an-item.json
// module id = 2659
// module chunks = 231608221292675